import React from "react";

const IsVerifiedIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15.1667C7.94667 15.1667 7.89329 15.158 7.84196 15.1407C6.78263 14.7873 1.5 12.748 1.5 7.25868V3.33339C1.5 3.09539 1.66802 2.88932 1.90202 2.84332C5.15535 2.19265 6.3087 1.62072 7.76937 0.896053C7.91004 0.826053 8.09664 0.816775 8.2373 0.886775C9.67797 1.61278 10.816 2.18665 14.0986 2.84332C14.3326 2.88998 14.5007 3.09539 14.5007 3.33339V7.25933C14.5007 12.7487 9.21802 14.788 8.15869 15.1413C8.10669 15.158 8.05333 15.1667 8 15.1667ZM2.5 3.74143V7.25868C2.5 11.8353 6.77867 13.6988 8 14.1368C9.22133 13.6988 13.5 11.8347 13.5 7.25868V3.74143C10.5527 3.12476 9.31326 2.54598 8.00993 1.89198C6.62526 2.57665 5.42333 3.13076 2.5 3.74143ZM7.69466 9.68674L10.3613 7.02008C10.5567 6.82474 10.5567 6.50805 10.3613 6.31272C10.166 6.11739 9.84931 6.11739 9.65397 6.31272L7.34066 8.62603L6.36068 7.64605C6.16534 7.45072 5.84865 7.45072 5.65332 7.64605C5.45799 7.84139 5.45799 8.15808 5.65332 8.35341L6.98665 9.68674C7.08399 9.78408 7.21201 9.83339 7.34001 9.83339C7.46801 9.83339 7.59733 9.78474 7.69466 9.68674Z"
      fill="#FF6C22"
    />
  </svg>
);

export default IsVerifiedIcon;
